import styled from "@emotion/styled";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
import "@mondaydotcomorg/monday-ui-components/dist/TilesList.css";
export const StyledCategoryIdToTileMapping = styled.div`
  .tile-items--container {
    row-gap: 20px;
    
    .tile-item--container {
      margin: 6px;
    }

    .tile-item--wrapper {
      display: flex;
      align-items: center;

      .tile-item--background {
        width: 100px;
        height: 100px;
        text-align: center;

        svg {
          width: calc(100% - 15px);
          height: calc(100% - 15px);
        }


      }

      .tile-item--label {
        font-size: 16px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .tiles-list--wrapper {
      text-align: center;

      .tile-items--container {
        margin-top: 16px;
        margin-right: -12px;
        justify-content: center;
        row-gap: 0px;

        .tile-item--container {
          margin: 6px 12px;

          .tile-item--wrapper {
            margin-top: 8px;
            width: calc(100vw / 2 - 40px);

            .tile-item--background {
              width: 100%;
              height: 52px;

              svg {
                height: 32px;
                width: auto;
              }


            }

            .tile-item--label {
              margin-top: 8px;
              font-size: 0.6875rem;
            }
          }
        }
      }
    }
  }
`;
